export class EligibilityPolicy {
  id: string;
  cluster: string;
  timeOnJob: number;
  maximumEarningsMultiplier: number;
  minimumRefinancePaidInstallments: number;
  incomeCommitment: number;
  createdBy: string;
  modifiedBy: string;

  constructor(data: string | EligibilityPolicy | DjangoEligibilityPolicy = {}) {
    if (data instanceof EligibilityPolicy) {
      bindEligibilityPolicyData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoEligibilityPolicyData(this, { id: data });
    } else {
      bindDjangoEligibilityPolicyData(this, data);
    }
  }
}

export interface DjangoEligibilityPolicy {
  id?: string;
  cluster?: string;
  time_on_job?: number;
  maximum_earnings_multiplier?: number;
  minimum_refinance_paid_installments?: number;
  income_commitment?: number;
  created_by?: string;
  modified_by?: string;
}

function bindEligibilityPolicyData(eligibilityPolicy: EligibilityPolicy, data: EligibilityPolicy) {
  eligibilityPolicy.id = data.id;
  eligibilityPolicy.cluster = data.cluster;
  eligibilityPolicy.timeOnJob = data.timeOnJob;
  eligibilityPolicy.maximumEarningsMultiplier = data.maximumEarningsMultiplier;
  eligibilityPolicy.minimumRefinancePaidInstallments = data.minimumRefinancePaidInstallments;
  eligibilityPolicy.incomeCommitment = data.incomeCommitment;
  eligibilityPolicy.createdBy = data.createdBy;
  eligibilityPolicy.modifiedBy = data.modifiedBy;
}

function bindDjangoEligibilityPolicyData(
  eligibilityPolicy: EligibilityPolicy,
  data: DjangoEligibilityPolicy,
) {
  eligibilityPolicy.id = data.id;
  eligibilityPolicy.cluster = data.cluster;
  eligibilityPolicy.timeOnJob = data.time_on_job;
  eligibilityPolicy.maximumEarningsMultiplier = data.maximum_earnings_multiplier;
  eligibilityPolicy.minimumRefinancePaidInstallments = data.minimum_refinance_paid_installments;
  eligibilityPolicy.incomeCommitment = data.income_commitment;
  eligibilityPolicy.createdBy = data.created_by;
  eligibilityPolicy.modifiedBy = data.modified_by;
}

export function parseEligibilityPolicy(
  data?: string | EligibilityPolicy | DjangoEligibilityPolicy,
) {
  if (data) {
    return new EligibilityPolicy(data);
  } else {
    return undefined;
  }
}
